module.exports = __webpack_public_path__ + "Variables.40fbf1d6481caa24a3b07f38de5ebd0f.hashedasset.svg";